import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { initAppleSignIn } from "@/lib/apple-signin";

interface RouterContext {
  queryClient: QueryClient;
}

const RootLayout = () => {
  useEffect(() => {
    initAppleSignIn();
  }, []);

  return (
    <div className="min-h-screen bg-paper text-ink">
      <Outlet />
    </div>
  );
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});
